import React from 'react';
import styles from './modifierBanner.module.css';

export const ModifierBanner = ({ content }: { content: string }) => (
  <div
    className={styles.banner}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);
